import styles from './styles.module.scss'

const Tab = () => {
    return <div className={styles['retailer']}></div>
}

export default Tab
